import { router } from 'expo-router';

const FINANCIAL_PROFILE_ROUTE = '/profile/financial-profile';

/**
 * Leaves an investment-profile sub-flow (risk, background, trusted contact) and
 * returns the user toward the financial profile hub.
 *
 * When the screen was reached via in-app navigation there is history to pop, so
 * we `router.back()` — this removes the sub-flow from the stack instead of
 * stacking the financial profile on top of it. When the screen was opened via a
 * deep link (e.g. https://my.fruitful.com/profile/investment/risk) the stack is
 * empty, so we `router.replace` to the hub. Using `replace` (not `navigate`)
 * keeps the sub-flow off the stack, which prevents a back-navigation loop where
 * the financial profile and the sub-flow bounce between each other and the user
 * can never reach the home screen.
 */
export const exitToFinancialProfile = () => {
    if (router.canGoBack()) {
        router.back();
    } else {
        router.replace(FINANCIAL_PROFILE_ROUTE);
    }
};
